module.exports = __webpack_public_path__ + "img/patent_image6.d17cbb4f.png";